import styles from "./CheckoutForm.module.css";

export default function CheckoutSuccess({ record, formatAmount, onContinue, onViewOrders }) {
  const isPO = record.kind === "po";
  return (
    <div className={styles.successCard}>
      <div className={styles.successIcon} aria-hidden>
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="4 12 10 18 20 6" />
        </svg>
      </div>
      <h2 className={styles.successTitle}>
        {isPO ? "Purchase Order submitted" : "Order placed"}
      </h2>
      <p className={styles.successLede}>
        {isPO
          ? "Your finance team has been notified. You will receive an email when the PO is approved and the order is released to NetSuite."
          : "Your order is now in NetSuite and will be released for fulfilment."}
      </p>

      <dl className={styles.successDetails}>
        <div><dt>Reference</dt><dd className={styles.mono}>{record.id}</dd></div>
        <div><dt>Status</dt><dd className={[styles.statusPill, isPO ? styles.statusPending : styles.statusOk].join(" ")}>
          {record.status?.replace(/_/g, " ")}
        </dd></div>
        {record.totals?.subtotal != null && (
          <div><dt>Subtotal</dt><dd>{formatAmount(record.totals.subtotal)}</dd></div>
        )}
      </dl>

      <div className={styles.actions}>
        <button type="button" className={styles.back} onClick={onContinue}>Continue Shopping</button>
        <button type="button" className={styles.next} onClick={onViewOrders}>View Orders</button>
      </div>
    </div>
  );
}
